import Reflux from "reflux";

/**
 * The goal of these actions is to handle result batches.
 */

export const select = Reflux.createAction();
export const unSelect = Reflux.createAction();
export const clear = Reflux.createAction();
export const get = Reflux.createAction();
export const level = Reflux.createAction();

export default { select, clear, get, level, unSelect };
